import { useParams } from 'react-router-dom';
import EventDashboardFrame from './EventDashboardFrame';
import SmallLoader from '@/src/Common/components/SmallLoader';
import { Divider } from '@/src/tailwindui/divider';
import useEventSharingSettings from './hooks/useEventSharingSettings';
import ShareAndGalleryForm from './ShareAndGalleryForm';

export default function EventDashboardSharing() {
    const { activationId } = useParams();
    const {
        isLoading,
        isSaving,
        lastSaved,
        lastChangesMade,
        foregroundColor,
        backgroundColor,
        headerForegroundColor,
        headerBackgroundColor,
        shareViaText,
        shareViaEmail,
        galleryLogo,
        setGalleryLogo,
        setForegroundColor,
        setBackgroundColor,
        setHeaderForegroundColor,
        setHeaderBackgroundColor,
        setShareViaText,
        setShareViaEmail,
        setCustomMessage,
        customMessage,
    } = useEventSharingSettings(activationId || '');

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <SmallLoader />
            </div>
        );
    }

    return (
        <EventDashboardFrame
            navLocation="sharing"
            activationId={activationId || ''}
        >
            <div className="flex flex-row gap-4 items-end h-[50px] justify-end mt-2">
                <div className="flex flex-col items-end justify-end ">
                    {isSaving && <SmallLoader />}
                    {lastChangesMade &&
                        lastSaved &&
                        lastChangesMade < lastSaved && (
                            <p className="text-sm text-gray-500 italic">
                                All Changes Saved
                            </p>
                        )}
                </div>
            </div>
            <Divider className="my-10" soft />
            <ShareAndGalleryForm
                foregroundColor={foregroundColor}
                backgroundColor={backgroundColor}
                headerForegroundColor={headerForegroundColor}
                headerBackgroundColor={headerBackgroundColor}
                shareViaText={shareViaText}
                shareViaEmail={shareViaEmail}
                galleryLogo={galleryLogo}
                setGalleryLogo={setGalleryLogo}
                setForegroundColor={setForegroundColor}
                setBackgroundColor={setBackgroundColor}
                setHeaderForegroundColor={setHeaderForegroundColor}
                setHeaderBackgroundColor={setHeaderBackgroundColor}
                setShareViaText={setShareViaText}
                setShareViaEmail={setShareViaEmail}
                setCustomMessage={setCustomMessage}
                customMessage={customMessage}
                onNext={() => {}}
            />
        </EventDashboardFrame>
    );
}
